import { ReflectionProbeMode } from "../../../../d3/component/Volume/reflectionProbe/ReflectionProbe";
import { RenderableSprite3D } from "../../../../d3/core/RenderableSprite3D";
import { Vector4 } from "../../../../maths/Vector4";
import { Vector2 } from "../../../../maths/Vector2";
export class WebBaseRenderNode {
    get shaderData() {
        return this._shaderData;
    }
    set shaderData(value) {
        this._shaderData = value;
    }
    _renderUpdatePre(context3D) {
        if (this._updateMark == context3D.cameraUpdateMask)
            return;
        this._renderUpdatePreFun.call(this._renderUpdatePreCall, context3D);
        this._updateMark = context3D.cameraUpdateMask;
    }
    _calculateBoundingBox() {
        this._caculateBoundingBoxFun.call(this._caculateBoundingBoxCall);
    }
    get bounds() {
        if (this.boundsChange) {
            this._calculateBoundingBox();
            this.boundsChange = false;
        }
        return this._bounds;
    }
    set bounds(value) {
        this._bounds = value;
    }
    get additionShaderData() {
        return this._additionShaderData;
    }
    set additionShaderData(value) {
        this._additionShaderData = value;
        if (value) {
            this._additionShaderDataKeys = Array.from(this._additionShaderData.keys());
        }
        else {
            this._additionShaderDataKeys = [];
        }
    }
    constructor() {
        this.ismoved = new Vector2();
        this.renderelements = [];
        this._commonUniformMap = [];
        this._worldParams = new Vector4(1, 0, 0, 0);
        this.lightmapDirtyFlag = -1;
        this.lightmapScaleOffset = new Vector4(1, 1, 0, 0);
        this.set_caculateBoundingBox(this, this._ownerCalculateBoundingBox);
        this._additionShaderData = new Map();
    }
    setNodeCustomData(dataSlot, data) {
        switch (dataSlot) {
            case 0:
                this._worldParams.y = data;
                break;
            case 1:
                this._worldParams.z = data;
                break;
            case 2:
                this._worldParams.w = data;
                break;
        }
    }
    set_renderUpdatePreCall(call, fun) {
        this._renderUpdatePreCall = call;
        this._renderUpdatePreFun = fun;
    }
    set_caculateBoundingBox(call, fun) {
        this._caculateBoundingBoxCall = call;
        this._caculateBoundingBoxFun = fun;
    }
    _needRender(boundFrustum) {
        if (boundFrustum)
            return boundFrustum.intersects(this.bounds);
        else
            return true;
    }
    setRenderelements(value) {
        this.renderelements.length = 0;
        for (var i = 0; i < value.length; i++) {
            this.renderelements.push(value[i]);
            value[i].owner = this;
        }
    }
    setOneMaterial(index, mat) {
        if (!this.renderelements[index])
            return;
        this.renderelements[index].materialShaderData = mat.shaderData;
        this.renderelements[index].materialRenderQueue = mat.renderQueue;
        this.renderelements[index].subShader = mat.shader.getSubShaderAt(0);
        this.renderelements[index].materialId = mat._id;
    }
    setLightmapScaleOffset(value) {
        value && value.cloneTo(this.lightmapScaleOffset);
    }
    setCommonUniformMap(value) {
        this._commonUniformMap.length = 0;
        value.forEach(element => {
            this._commonUniformMap.push(element);
        });
    }
    shadowCullPass() {
        return this.castShadow && this.enable && (this.renderbitFlag == 0);
    }
    _ownerCalculateBoundingBox() {
        this.baseGeometryBounds._tranform(this.transform.worldMatrix, this._bounds);
    }
    _applyLightMapParams() {
        let shaderValues = this.shaderData;
        if (this.lightmap) {
            let lightMap = this.lightmap;
            shaderValues.setVector(RenderableSprite3D.LIGHTMAPSCALEOFFSET, this.lightmapScaleOffset);
            shaderValues._setInternalTexture(RenderableSprite3D.LIGHTMAP, lightMap.lightmapColor);
            shaderValues.addDefine(RenderableSprite3D.SAHDERDEFINE_LIGHTMAP);
            if (lightMap.lightmapDirection) {
                shaderValues._setInternalTexture(RenderableSprite3D.LIGHTMAP_DIRECTION, lightMap.lightmapDirection);
                shaderValues.addDefine(RenderableSprite3D.SHADERDEFINE_LIGHTMAP_DIRECTIONAL);
            }
            else {
                shaderValues.removeDefine(RenderableSprite3D.SHADERDEFINE_LIGHTMAP_DIRECTIONAL);
            }
        }
        else {
            shaderValues.removeDefine(RenderableSprite3D.SAHDERDEFINE_LIGHTMAP);
            shaderValues.removeDefine(RenderableSprite3D.SHADERDEFINE_LIGHTMAP_DIRECTIONAL);
        }
    }
    _applyLightProb() {
        if (this.lightmapIndex >= 0 || !this.volumetricGI)
            return;
        if (this.volumetricGI.updateMark != this.lightProbUpdateMark) {
            this.lightProbUpdateMark = this.volumetricGI.updateMark;
            this.volumetricGI.applyRenderData();
        }
    }
    _applyReflection() {
        if (!this.probeReflection || this.reflectionMode == ReflectionProbeMode.off)
            return;
        if (this.probeReflection.needUpdate()) {
            this.probeReflection.applyRenderData();
        }
    }
    destroy() {
        this.renderelements.forEach(element => {
            element.destroy();
        });
        this.baseGeometryBounds = null;
        this.transform = null;
        this.lightmapScaleOffset = null;
        this.lightmap = null;
        this.probeReflection = null;
        this.volumetricGI = null;
        this.renderelements.length = 0;
        this.renderelements = null;
        this.shaderData && this.shaderData.destroy();
        this.shaderData = null;
        this._commonUniformMap.length = 0;
        this._commonUniformMap = null;
        this.additionShaderData.clear();
        this.additionShaderData = null;
        this._additionShaderDataKeys.length = 0;
        this._additionShaderDataKeys = null;
    }
}
